export const errorTransformer = (error): string =>
  `Error status ${error.status}. Message: ${error.body?.message}` ||
  error.body?.errors?.join('/n') ||
  `${error.status}: ${error.message}` ||
  'Something went wrong';
